import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider} from "react-redux";
import {Provider as MobxProvider} from "mobx-react";
import { setupStore } from "services/store";
import { Router } from "routing/Router";
import GlobalStyles from "theme/globalStyles";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "@aws-amplify/core";
import awsAmplify from "amplifyConfiguration";
import muiTheme from "./theme/muiTheme";
import { ThemeProvider } from "@mui/material";
import Store from "./guidelines/store/Store";

const container = document.getElementById("bc-root")!;
const root = createRoot(container);

Amplify.configure(awsAmplify);
if (process.env.NODE_ENV !== 'development') {
  (function (w, d, s, l, i) {
    // @ts-ignore
    w[l] = w[l] || [];
    // @ts-ignore
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    let f = d.getElementsByTagName(s)[0],
      j = d.createElement(s) as HTMLScriptElement,
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode?.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-WKPZXH9');
  const noscriptTag = document.createElement('noscript');
  const iframeTag = document.createElement('iframe');
  iframeTag.src = 'https://www.googletagmanager.com/ns.html?id=GTM-WKPZXH9';
  iframeTag.height = '0';
  iframeTag.width = '0';
  iframeTag.style.display = 'none';
  iframeTag.style.visibility = 'hidden';
  noscriptTag.appendChild(iframeTag);
  document.body.prepend(noscriptTag);
}

root.render(
  // <React.StrictMode>
  <ReduxProvider store={setupStore()}>
    <ThemeProvider theme={muiTheme}>
      <GlobalStyles />
      <MobxProvider store={Store}>
        <Router />
      </MobxProvider>
    </ThemeProvider>
  </ReduxProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
